import { type ReactNode, useCallback, useMemo, useState } from 'react'

import { ModelDataSecurityContext, type ModelConfidentiality, type ModelDataSecurityContextValue } from './context'

const MODEL_CONFIDENTIALITY: Record<string, ModelConfidentiality> = {
  azure: 'company-confidential',
  bedrock: 'company-confidential',
  openai: 'non-company-confidential',
  'bedrock-converse': 'company-confidential',
  ollama: 'company-confidential',
  vertex: 'company-confidential',
}

export function ModelDataSecurityProvider({ children }: { children: ReactNode }) {
  const [confidentiality, setConfidentiality] = useState<ModelConfidentiality>()
  const setModelType = useCallback(
    (modelType?: string) => setConfidentiality(modelType ? MODEL_CONFIDENTIALITY[modelType] ?? 'non-company-confidential' : undefined),
    []
  )
  const value = useMemo<ModelDataSecurityContextValue>(
    () => ({ confidentiality, setConfidentiality, setModelType }),
    [confidentiality, setModelType]
  )

  return <ModelDataSecurityContext.Provider value={value}>{children}</ModelDataSecurityContext.Provider>
}
